module.exports = new __parcel__URL__("map-planning.6651464b.svg").toString();